import locales from "@alienfast/i18next-loader?basenameAsNamespace=true!./index.js";
export default locales;